import React, { useState, useEffect } from 'react'
import { Button, Typography } from '@mui/material';
import { Modal } from 'react-bootstrap'
import UpdateForm from './UpdateForm'

export default function AffiliateOTAMapping() {

  const [lgShow, setLgShow] = useState(false);
  const [accessType, setAccessType] = useState('');

  //API call
  useEffect(() => {

    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);

    if (foundUser.role_capabilities?.all_modules_access === true) {

      setAccessType('Edit');

    }
    else {

      setAccessType(foundUser.access['AffiliateOTAMapping_Access Specifier']);
    }

  }, []);

  return (
    <>


      <div className="row my-3 ">
        <div className="col-md-6">
          <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
            Affiliate OTA Mapping {accessType === 'View' && "/ View Only Mode"}
          </Typography>
        </div>
        <div className="col-md-6 d-flex justify-content-end"   >

          <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button>
          <Modal
            size="lg"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"

          >
            <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
              <Modal.Title id="example-modal-sizes-title-lg" >
                Instructions to do Affiliate OTA Mapping
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h5>Select account to proceed ahead:
              </h5>
              <ol>
                <li>Select the Corporate Account Name from the dropdown
                </li>
                <li>Select the OTA name from the checkbox</li>
                <li>Click on Save button
                </li>
              </ol>

              <h5>Existing Records:
              </h5>
              <ul>
                <li>To view the existing Rate Rules select the Corporate Account Name from the dropdown.
                </li>
              </ul>

            </Modal.Body>
          </Modal>

        </div>
      </div>


      {/* <div className="col-4 d-flex justify-content-end px-5">
        
          
         
        </div> */}



      {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}


    </>
  );
}
